import React from 'react'
import PageHeader from "../components/PageHeader";
import { sansthanImg } from "../assets/assets.js";
import "../css/commontemplate.css";

export const Mahashivratra = () => {
    return (
        <>  
            <PageHeader title="महाशिवरात्र पदयात्रा " path="/about-goshala" name=" goshala" />
            {/* <Initiatives /> */}
            <div className="comman-template-section">
           
              <div className="comman-template-container">
                {/* container  */}
                <div className="comman-template-sub-section">
                  {/* sub-section */}
                  <div className="comman-template-img-container">
                   
                    <img
                      className="comman-template-image"
                      src={sansthanImg.s_img07}
                      alt=""
                    />
                  </div>
                  <div className="comman-template-info-container">
                    {/* info container */}
                     {/* <h3>गोसेवेचे महत्त्व</h3> */}
                    <div className="comman-template-info-container-shlok">
                    यस्य नि:श्वसितं वेदा यो वेदेभ्योऽखिलं जगत् । <br />
                    निर्ममे तमहं वन्दे विद्यातीर्थं महेश्वरम् ॥
                      </div>
                    <p>
                    &nbsp;  &nbsp;  &nbsp; &nbsp;   &nbsp; &nbsp;   भारतीय संस्कृतीत वेदांना अनन्यसाधारण महत्व आहे. वेदांचे महत्व ऋषी-महर्षींनी अंतर्ज्ञानाने जाणून घेवून सर्वांच्या कल्याणार्थ प्रगट केले. हिंदू राष्ट्राची जीवन प्रणाली एका खंबीर अधिष्ठानावर उभी आहे. वेद व देव भारतीय संस्कृतीचे मूलाधार आहेत. वेद वाङ्मय जगातील सर्वाधिक प्राचीन वाङ्मय आहे. 
                    विज्ञान युगातही त्याचे महत्व अबाधित आहे. काळाच्याओघात काही संकटे, बदलत्या विचारधारा, प्रतिकूल परिस्थितीमुळे वेदज्ञान, त्यातील रहस्य, गूढज्ञान लुप्त होण्याची भिती निर्माण झाली आहे. अशा स्थितीतही काही संस्कृतिनिष्ठ वेदभक्तांनी ईश्वरी आशीर्वाद, प्रबल इच्छाशक्तीच्या सामर्थ्यावर वेदज्ञानाचा वारसा प्राणपणाने जपला. वेदांच्या संरक्षण व संवर्धनाचे कार्य हाती घेतले. अशा काही ज्येष्ठ-श्रेष्ठ महात्म्यां मधील एक थोर विभूती म्हणजेच परमपूज्य श्रीसद्गुरू वेंकटेश दाजीमहाराज हे होत.
                    </p>
                  </div>
                </div>

                
      
                <div className="comman-template-sub-section"></div>
              </div>
            </div>

        </>
    );
}
